import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "./App.css";
import { setLenis } from "./lib/scroll";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Gallery from "./components/Gallery";
import Packages from "./components/Packages";
import Schedule from "./components/Schedule";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Inbox from "./components/Inbox";
import AuthCallback from "./components/AuthCallback";
import AuthDest from "./components/AuthDest";
import SignIn from "./components/SignIn";
import MyGames from "./components/MyGames";
import ResetPassword from "./components/ResetPassword";
import PaymentResult from "./components/PaymentResult";
import Reschedule from "./components/Reschedule";
import PhotoGallery from "./components/PhotoGallery";
import GalleryHub from "./components/GalleryHub";
import Reviews from "./components/Reviews";
import InstagramFeed from "./components/InstagramFeed";

function AppRouter() {
  const location = useLocation();
  // Handles the Emergent Google Auth redirect: #session_id=... must be
  // processed before any existing-session check runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Self-service password reset links land here: /?reset=<token>
  if (location.search?.includes("reset=")) {
    return <ResetPassword />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/inbox" element={<Inbox />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/my-games" element={<MyGames />} />
      <Route path="/auth/dest" element={<AuthDest />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
      <Route path="/reschedule" element={<Reschedule />} />
      <Route path="/gallery-hub" element={<GalleryHub />} />
      <Route path="/gallery/:bookingId" element={<PhotoGallery />} />
    </Routes>
  );
}

class ErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink p-10 text-center">
          <p className="text-lg text-white/70">Something went wrong. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="relative min-h-screen overflow-x-clip bg-ink font-body text-white">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Gallery />
        <Packages />
        <Schedule />
        <About />
        <Reviews />
        <InstagramFeed />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
